import React, { useEffect, useState } from 'react';
const TOTAL_SECONDS = 17 * 60 + 34;
type CountdownProps = {
  size?: 'sm' | 'md';
};
function pad(value: number): string {
  return value.toString().padStart(2, '0');
}
export function Countdown({
  size = 'md'
}: CountdownProps) {
  const [remaining, setRemaining] = useState(TOTAL_SECONDS - 1);
  useEffect(() => {
    const id = window.setInterval(() => {
      setRemaining(prev => prev <= 0 ? TOTAL_SECONDS - 1 : prev - 1);
    }, 1000);
    return () => window.clearInterval(id);
  }, []);
  const hours = Math.floor(remaining / 3600);
  const minutes = Math.floor(remaining % 3600 / 60);
  const seconds = remaining % 60;
  const boxes = [{
    value: pad(hours),
    unit: 'Heures'
  }, {
    value: pad(minutes),
    unit: 'Min'
  }, {
    value: pad(seconds),
    unit: 'Sec'
  }];
  const digit = size === 'sm' ? 'text-2xl' : 'text-3xl sm:text-4xl';
  const box = size === 'sm' ? 'w-16 py-1.5' : 'w-[4.5rem] sm:w-20 py-2';
  return <div className="flex flex-col items-center gap-2" data-id="element-18" data-mp="159byfq04204u">
      <p className="text-[11px] font-bold uppercase tracking-[0.22em] text-white/55" data-id="element-19" data-mp="y04y68boxut5">
        L’offre se termine dans
      </p>
      <div className="flex items-center gap-1.5" role="timer" aria-live="off" aria-label={`Offre se termine dans ${hours} heures ${minutes} minutes ${seconds} secondes`} data-id="element-20" data-mp="t1tn5u9nte9c">
        {boxes.map((b, i) => <React.Fragment key={b.unit} data-id="element-21" data-mp="f22ca2efwdzk" data-mpi={i}>
            {i > 0 && <span className="pb-4 text-xl font-bold text-spark-500" data-id="element-22" data-mp="f2u89eby8dqd">:</span>}
            <div className={`${box} rounded-lg border border-white/10 bg-ink-800 text-center shadow-[inset_0_1px_0_rgba(255,255,255,0.06)]`} data-id="element-23" data-mp="a4997i8fo03i">
              <div className={`${digit} font-display font-bold leading-none text-spark-400`} data-id="element-24" data-mp="k1ncsh99cuee">
                {b.value}
              </div>
              <div className="mt-1 text-[9px] font-semibold uppercase tracking-[0.18em] text-white/45" data-id="element-25" data-mp="1zguoygld8qnu">
                {b.unit}
              </div>
            </div>
          </React.Fragment>)}
      </div>
    </div>;
}